import { PortfolioReturnsInitValueElement } from 'communication/types/portfolioReturns/PortfolioReturnsDataElement';
export interface PortfolioReturnsDataInitPortfolioValues {
    /*
     * Latest (maximum) trading date in returned portfolio data
     */
    maxTradingDateTimestamp: number;
    /*
     * Portfolio values corresponding to p[0-5] values in main timeseries array,
     * but calculated (on the server) using the previous close prices as of now.
     */
    values: number[];
}

export function mapToPortfolioReturnsDataInitPortfolioValuesFromElement(
    from: PortfolioReturnsInitValueElement
): PortfolioReturnsDataInitPortfolioValues {
    return {
        maxTradingDateTimestamp: from.m,
        values: from.v,
    };
}
